"use client";

import type { Mission } from "@/lib/content/types";
import { useAccountStatistics } from "./accounts";
import { missionProgress, type MissionProgress } from "./mission-progress";
import { useIdentity } from "./session";

export type MissionState = { mission: Mission; progress: MissionProgress | null };

export const useMissions = (missions: Mission[]) => {
  const { identity, isSignedIn } = useIdentity();
  const query = useAccountStatistics(identity?.id, isSignedIn);

  const states: MissionState[] = missions.map((mission) => ({
    mission,
    progress: query.data ? missionProgress(mission, query.data) : null,
  }));

  return {
    ...query,
    states,
    isSignedIn,
    completed: states.filter((state) => state.progress?.complete).length,
  };
};
